/* Examples:

  <InputBoxes
    v-model="form.maxMinutes"
    inputFrom="right"
    treatAs="datetimeinput"
    :disabled="maxDuration != 'maxMinutes'">
  </InputBoxes>

  <InputBoxes
    inputRef="z"
    :max="8"
    :disabled="maxDuration != 'maxMinutes'">
  </InputBoxes>

*/

<template>

  <div class="input-boxes-contents">
    <div v-for="(ref, index) in realInputRef" class="input-boxes-wrapper">
      <input type="text" class="form__input input-boxes" :style="{color: errors.has(`${realLabel[index]}`) ? 'orange' : 'green'}"
        :name="realLabel[index]"
        v-model="$data[`contentFOR${ref}`]"
        v-validate="realValidate[index]"
        :data-vv-as="realLabel[index]"
        data-vv-delay="0"
        @keydown.stop="handleInputKeyDown(index);"
        @keyup="(inputFrom === 'right' ? handleRightInputKeyUp($event, index) : handleLeftInputKeyUp($event, index))"
        :ref="ref"/>
      <div class="input-reproduction" :class="{disabled: disabled}" :style="{ width: (boxWidth * realMax[index]) + 'px', }">
        <span class="input-character"
        :style="{ width: 'calc( (100% - ' + (realMax[index] * 5) + 'px) / ' + realMax[index] + ')', marginRight: 5 + 'px' }"
        v-for="number in realMax[index]"
        @click="disabled ? '' : (inputFrom === 'right' ? handleRightInputBoxClick(number, index) : handleLeftInputBoxClick(number, index))">
          {{  (inputFrom === 'right') ?
               typeof $data[`contentFOR${ref}`].split('').reverse()[realMax[index] - number] === 'undefined' ? '' : $data[`contentFOR${ref}`].split('').reverse()[realMax[index] - number] :
               typeof $data[`contentFOR${ref}`].split('')[number - 1] === 'undefined' ? '' : $data[`contentFOR${ref}`].split('')[number - 1]  }}
          <span class="input-cursor-down" v-if="number === caretPosition[index]" v-show="animationShow[index] && !disabled"></span>
        </span>
      </div>
      <label class="input-reproduction-label" :class="{disabled: disabled}" :for="realLabel[index]" v-if="realLabel[index] && realLabel[index] !== ''">{{ realLabel[index] }}</label>
    </div>
  </div>

</template>

<script>

import moment from 'moment';

export default {
  props: {
    inputRef: {
      type: [Array, String],
      required: false,
      default: 'qwerty',
    },
    label: {
      type: [Array, String],
      required: false,
      default: '',
    },
    max: {
      type: [Array, Number],
      required: false,
      default: 25,
    },
    boxWidth: {
      type: Number,
      required: false,
      default: 25,
    },
    inputFrom: {
      type: String,
      required: false,
      default: 'left',
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    validate: {
      type: [Array, String],
      required: false,
      default: '',
    },
    value: {
      type: [String, Number, Array],
      required: false,
      default: '',
    },
    treatAs: {
      type: String,
      required: false,
      default: 'input',
    },
    maxDays: {
      type: Number,
      required: false,
      default: 365,
    },
  },
  watch: {
    value(newContent) {
      if (this.isDateTimeInput()) {
        const duration = JSON.parse(`[${moment.duration(newContent, 'minutes').format('d, h, m', { trim: false })}]`);
        this.contentFORbyDays = (newContent === '' ? '0' : `${duration[0]}`);
        this.contentFORbyHours = (newContent === '' ? '0' : `${duration[1]}`);
        this.contentFORbyMinutes = (newContent === '' ? '0' : `${duration[2]}`);
      }
    },
  },
  data() {
    return Object.assign(this.getContentVariables(), {
      caretPosition: this.getCaretPositions(),
      animationShow: this.getAnimations(),
      elSelectionEndWas: '',
      contentWas: '',
      realInputRef: this.getRealInputRef(),
      realLabel: this.getRealLabel(),
      realMax: this.getRealMax(),
      realValidate: this.getRealValidate(),
      realValue: this.getRealValue(),
    });
  },
  created() {
    for (let i = 0; i < this.realInputRef.length; i += 1) {
      setInterval(() => this.animateCursor(i), 400);
    }
    this.initWatchers();
  },
  methods: {
    getRealInputRef() {
      if (this.isDateTimeInput()) {
        return ['byDays', 'byHours', 'byMinutes'];
      } else if (typeof this.inputRef === 'string') {
        return [this.inputRef];
      }
      return this.inputRef;
    },
    getRealLabel() {
      if (this.isDateTimeInput()) {
        return [this.$tc('pricingrules.day', 2), this.$t('pricingrules.hour'), this.$t('pricingrules.minute')];
      } else if (typeof this.label === 'string') {
        return [this.label];
      }
      return this.label;
    },
    getRealMax() {
      if (this.isDateTimeInput()) {
        return [3, 2, 2];
      } else if (typeof this.max === 'number') {
        return [this.max];
      }
      return this.max;
    },
    getRealValidate() {
      if (this.isDateTimeInput()) {
        return [`max_value:${this.maxDays}`, 'max_value:99', 'max_value:99'];
      } else if (typeof this.validate === 'string') {
        return [this.validate];
      }
      return this.validate;
    },
    getRealValue() {
      if (this.isDateTimeInput()) {
        const duration = JSON.parse(`[${moment.duration(this.value, 'minutes').format('d, h, m', { trim: false })}]`);
        return [
          this.value === '' ? '0' : `${duration[0]}`,
          this.value === '' ? '0' : `${duration[1]}`,
          this.value === '' ? '0' : `${duration[2]}`,
        ];
      } else if (typeof this.value !== 'object') {
        return [this.value];
      }
      return this.value;
    },
    isDateTimeInput() {
      return this.treatAs === 'datetimeinput';
    },
    initWatchers() {
      const obj = this.getContentVariables();
      const keys = Object.keys(obj);
      for (let i = 0; i < keys.length; i += 1) {
        this.$watch(keys[i], this.watcherMethod.bind(this, keys[i]));
      }
    },
    watcherMethod(to, newContent, oldContent) {
      const el = this.$refs[to.replace('contentFOR', '')][0];
      el.value = newContent;
      if (this.isDateTimeInput() && this.getMinutes() > ((this.maxDays + 1) * 24 * 60)) {
        this[to] = oldContent;
        this.$emit('input', this.getMinutes());
        return;
      }
      this.$validator.validateAll()
        .then((success) => {
          if (!success) {
            this[to] = oldContent;
            this.$emit('input', this.isDateTimeInput() ? this.getMinutes() : this.getArrayOfValues());
          } else {
            this.$emit('input', this.isDateTimeInput() ? this.getMinutes() : this.getArrayOfValues());
          }
        });
    },
    getContentVariables() {
      const realInputRef = this.getRealInputRef();
      const realValue = this.getRealValue();
      const obj = {};
      for (let i = 0; i < realInputRef.length; i += 1) {
        obj[`contentFOR${realInputRef[i]}`] = realValue[i] || '';
      }
      return obj;
    },
    getArrayOfValues() {
      const arr = [];
      for (let i = 0; i < this.realInputRef.length; i += 1) {
        arr.push(this[`contentFOR${this.realInputRef[i]}`]);
      }
      return arr;
    },
    getMinutes() {
      const days = this.contentFORbyDays === '' ? 0 : (parseInt(this.contentFORbyDays, 10) * 24 * 60);
      const hours = this.contentFORbyHours === '' ? 0 : (parseInt(this.contentFORbyHours, 10) * 60);
      const minutes = this.contentFORbyMinutes === '' ? 0 : (parseInt(this.contentFORbyMinutes, 10));
      return days + hours + minutes;
    },
    handleInputKeyDown(index) {
      const el = this.$refs[this.realInputRef[index]][0];
      this.elSelectionEndWas = el.selectionEnd;
      this.contentWas = el.value;
      this.caretPosition[index] = el.selectionStart + 1;
      if (this.inputFrom === 'right') {
        this.caretPosition[index] = this.getCaretCorrectPosition(el.selectionStart + 1, index);
      }
      if (el.selectionStart + 1 > this.realMax[index]) {
        el.selectionStart = this.realMax[index] - 1;
        el.selectionEnd = this.realMax[index];
        this.caretPosition[index] = this.realMax[index];
      }
    },
    handleLeftInputKeyUp(event, index) {
      const el = this.$refs[this.realInputRef[index]][0];
      const arr = this[`contentFOR${this.realInputRef[index]}`].split('');
      this.caretPosition[index] = el.selectionStart + 1;
      if (this.contentWas.split('').length > arr.length
        && (event.key === 'Backspace' || event.keyCode === 8)) {
        el.selectionEnd = el.selectionStart;
        el.selectionStart -= 1;
        this.caretPosition[index] = el.selectionStart + 1;
      } else if (
        /* (this.contentWas.split('').length > arr.length
        && (event.key === 'Delete' || event.key === 'Del' || event.keyCode === 46))
        || */ this.contentWas.split('').length > arr.length) {
        el.selectionEnd = el.selectionStart + 1;
        this.caretPosition[index] = el.selectionStart + 1;
      } else if (el.selectionStart <= 0) {
        el.selectionEnd = 1;
        el.selectionStart = 0;
        this.caretPosition[index] = 1;
      } else if (el.selectionStart === el.selectionEnd
        && this.elSelectionEndWas > el.selectionEnd) {
        el.selectionEnd = el.selectionStart;
        this.caretPosition[index] = el.selectionStart;
        el.selectionStart -= 1;
      } else if (el.selectionStart === el.selectionEnd
        && this.elSelectionEndWas === el.selectionEnd) {
        el.selectionEnd = el.selectionStart + 1;
        this.caretPosition[index] = el.selectionStart + 1;
      }
      if (el.selectionStart + 1 >= this.realMax[index]) {
        el.selectionStart = this.realMax[index] - 1;
        el.selectionEnd = this.realMax[index];
        this.caretPosition[index] = this.realMax[index];
      }
    },
    handleRightInputKeyUp(event, index) {
      const el = this.$refs[this.realInputRef[index]][0];
      const arr = this[`contentFOR${this.realInputRef[index]}`].split('');
      this.caretPosition[index] = this.getCaretCorrectPosition(el.selectionStart, index);
      if (this.contentWas.split('').length > arr.length
        && (event.key === 'Backspace' || event.keyCode === 8)) {
        el.selectionEnd = el.selectionStart;
        el.selectionStart -= 1;
        this.caretPosition[index] = this.getCaretCorrectPosition(el.selectionStart + 1, index);
      } else if (
        /* (this.contentWas.split('').length > arr.length
        && (event.key === 'Delete' || event.key === 'Del' || event.keyCode === 46))
        || */ this.contentWas.split('').length > arr.length) {
        el.selectionEnd = el.selectionStart + 1;
        this.caretPosition[index] = this.getCaretCorrectPosition(el.selectionStart + 1, index);
      } else if (el.selectionStart <= 0) {
        el.selectionEnd = 1;
        el.selectionStart = 0;
        this.caretPosition[index] = this.getCaretCorrectPosition(1, index);
      } else if (el.selectionStart === el.selectionEnd
        && this.elSelectionEndWas > el.selectionEnd) {
        el.selectionEnd = el.selectionStart;
        this.caretPosition[index] = this.getCaretCorrectPosition(el.selectionStart, index);
        el.selectionStart -= 1;
      } else if (el.selectionStart === el.selectionEnd
        && this.elSelectionEndWas === el.selectionEnd) {
        el.selectionEnd = el.selectionStart + 1;
        this.caretPosition[index] = this.getCaretCorrectPosition(el.selectionStart + 1, index);
      }
      if (el.selectionStart + 1 >= this.realMax[index]) {
        el.selectionStart = this.realMax[index] - 1;
        el.selectionEnd = this.realMax[index];
        this.caretPosition[index] = this.realMax[index];
      }
    },
    handleLeftInputBoxClick(boxNumber, index) {
      const el = this.$refs[this.realInputRef[index]][0];
      el.focus();
      el.selectionStart = boxNumber - 1;
      el.selectionEnd = boxNumber;
      this.caretPosition[index] = el.selectionEnd < 1 ? 1 : el.selectionEnd;
    },
    handleRightInputBoxClick(boxNumber, index) {
      const el = this.$refs[this.realInputRef[index]][0];
      const arr = this[`contentFOR${this.realInputRef[index]}`].split('');
      el.focus();
      const indexes = this.getArrIndexes(index);
      if (arr.length === 0) {
        this.caretPosition[index] = this.realMax[index];
        el.selectionStart = 0;
        el.selectionEnd = 1;
        return;
      }
      if (indexes[boxNumber - 1] === 'X') {
        el.selectionStart = 0;
        el.selectionEnd = 1;
        this.caretPosition[index] = (this.realMax[index] - arr.length) + 1;
        return;
      }
      el.selectionStart = indexes[boxNumber - 1] - 1;
      el.selectionEnd = indexes[boxNumber - 1];
      this.caretPosition[index] = boxNumber;
    },
    getArrIndexes(index) {
      if (this.inputFrom !== 'right') {
        const obj = this.getContentVariables();
        const keys = Object.keys(obj);
        return this[keys[index]].split('').map((value, i) => i + 1);
      }
      const arr = this[`contentFOR${this.realInputRef[index]}`].split('');
      const emptyIndexes = [];
      const filledIndexes = [];
      let count = 0;
      for (let i = 1; i <= this.realMax[index]; i += 1) {
        if (i > arr.length) {
          emptyIndexes.push('X');
        } else {
          count += 1;
          filledIndexes.push(count);
        }
      }
      return emptyIndexes.concat(filledIndexes);
    },
    getCaretCorrectPosition(pos, index) {
      const indexes = this.getArrIndexes(index);
      const correctPos = indexes.indexOf(pos) + 1;
      return correctPos === 0 ? this.realMax[index] : correctPos;
    },
    getCaretPositions() {
      const realInputRef = this.getRealInputRef();
      const realMax = this.getRealMax();
      const arr = [];
      for (let i = 0; i < realInputRef.length; i += 1) {
        if (this.inputFrom === 'right') {
          arr.push(realMax[i]);
        } else {
          arr.push(1);
        }
      }
      return arr;
    },
    getAnimations() {
      const realInputRef = this.getRealInputRef();
      const arr = [];
      for (let i = 0; i < realInputRef.length; i += 1) {
        arr.push(false);
      }
      return arr;
    },
    animateCursor(index) {
      if (this.$refs[this.realInputRef[index]][0] === document.activeElement) {
        this.animationShow.splice(index, 1, !this.animationShow[index]);
      } else {
        this.animationShow.splice(index, 1, false);
      }
    },
  },
};
</script>

<style lang="scss" scoped>

  @import '~styles/variables.scss';

  .input-boxes-wrapper {
    display: inline-block;
  }

  .input-boxes {

    background: transparent !important;
    width: 0!important;
    height: 0!important;
    font-size: 1px!important;
    right: 0;
    bottom: 0;
    position: absolute;
    text-align: left!important;
    background-color: transparent!important;
    letter-spacing: 15px;
    z-index: 1;
    color: transparent!important;

    &::-moz-selection {
        color: transparent;
        background: transparent;
    }

    &::selection {
        color: transparent;
        background: transparent;
    }

  }

  .input-reproduction-label {
    vertical-align: bottom;
    margin-right: 8px;

    &.disabled {
      color: $grey-five;
    }

  }

  .input-reproduction {
    z-index: 20;
    /*padding-top: 16px;*/
    width: 100%;
    max-width: 300px;
    height: 100%;
    white-space: nowrap;
    display: inline-block;


    .input-character {
      position: relative;
      display: inline-block;
      background: $grey-five;
      margin-right: 5px;
      width: 20px;
      font-size: 18px;
      height: 25px;
      text-align: center;
      line-height: 25px;
      font-weight: 700;
      vertical-align: top;
      cursor: text;

    }

    .input-cursor-down {

      position: absolute;
      bottom: 0;
      right: 0;
      height: 100%;
      width: 100%;
      border-bottom: 1px solid black;
      overflow: hidden;

    }

    &.disabled {
      .input-character {
        background: $grey-six;
        color: $grey-five;
      }
    }

  }

</style>



// WEBPACK FOOTER //
// src/components/common/InputBoxes.vue